// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-nastupna-predavanja {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  border: 1px solid #e6e9ec;
  box-shadow: 0px 1px 2px 0px #1018280a;
  border-radius: 8px;
  background-color: white;
  min-width: 1120px;
}

.table-wrapper {
  border: 1px solid #e6e9ec;
  overflow-x: auto;
  width: 100%;
  border-bottom: 0;
}

.table-nastupna-predavanja th,
.table-nastupna-predavanja td {
  padding: 16px 32px 16px 32px;
  border-bottom: 1px solid #d1d9e2;
}
.table-nastupna-predavanja tr:last-child {
  border-bottom: none;
}
.table-nastupna-predavanja th,
.table-nastupna-predavanja tr {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.table-nastupna-predavanja th,
.table-nastupna-predavanja tr,
.first-column-name {
  text-align: left;
  font-family: Inter;
  letter-spacing: -0.001em;
  color: #5f6d7e;
}
.edit-delete-btn-row {
  gap: 16px;
  padding: 12px;
}
.table-nastupna-predavanja-column,
.table-nastupna-predavanja-btn,
.table-nastupna-predavanja-btn-disabled,
.delete-nastupno-predavanje-btn,
.edit-nastupno-predavanje-btn,
.edit-delete-btn-row {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-nastupna-predavanja-custom-border {
  border-right: 1px solid #d1d9e2;
}
.table-nastupna-predavanja th {
  padding: 16px 0px 16px 24px;
}
.table-nastupna-predavanja tr {
  font-weight: 500;
}
.table-nastupna-predavanja-column {
  flex-direction: column;
  width: 100%;
}
.table-nastupna-predavanja-btn,
.edit-nastupno-predavanje-btn {
  background-color: #cb9c2d;
}
.table-nastupna-predavanja-btn:hover,
.edit-nastupno-predavanje-btn:hover {
  background-color: #9c7926;
}
.table-nastupna-predavanja-btn:hover,
.delete-nastupno-predavanje-btn:hover,
.edit-nastupno-predavanje-btn:hover {
  cursor: pointer;
  transition: background-color 300ms ease-in-out;
}
.table-nastupna-predavanja-btn-disabled {
  cursor: not-allowed;
  background-color: #818181;
  opacity: 0.4;
}
.delete-nastupno-predavanje-btn,
.edit-nastupno-predavanje-btn {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  padding: 8px;
  border: none;
}
.delete-nastupno-predavanje-btn {
  background-color: #cb2d2d;
  cursor: pointer;
}

.delete-nastupno-predavanje-btn:hover {
  background-color: #8f1c1c;
}
.delete-nastupno-predavanje-trash,
.edit-nastupno-predavanje-icon {
  width: 24px;
  height: 24px;
}
.edit-nastupno-predavanje-icon,
.delete-nastupno-predavanje-trash {
  filter: brightness(0) invert(1) grayscale(100%);
}
.table-nastupna-predavanja-btn-disabled,
.table-nastupna-predavanja-btn {
  padding: 0px 10px 0px 10px;
  gap: 6px;
  border: none;
  border-radius: 4px;
  height: 40px;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  width: max-content;
  letter-spacing: -0.001em;
  text-align: left;
  color: white;
}
.table-nastupna-predavanja-avatar {
  width: 32px;
  height: 32px;
  border-radius: 100px;
}
.table-nastupna-predavanja-status {
  margin-top: -10px;
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: -0.001em;
  text-align: center;
  color: #9fa7b2;
}

.first-column-name {
  font-size: 20px;
  font-weight: 600;
  line-height: 18px;
}
`, "",{"version":3,"sources":["webpack://./src/scenes/evidencija/components/NastupnoPredavanjeTable/PredavanjeTable.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,SAAS;EACT,aAAa;AACf;AACA;;;;;;EAME,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;EAGE,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,YAAY;AACd;AACA;;EAEE,+CAA+C;AACjD;AACA;;EAEE,0BAA0B;EAC1B,QAAQ;EACR,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".table-nastupna-predavanja {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 10px;\n  border: 1px solid #e6e9ec;\n  box-shadow: 0px 1px 2px 0px #1018280a;\n  border-radius: 8px;\n  background-color: white;\n  min-width: 1120px;\n}\n\n.table-wrapper {\n  border: 1px solid #e6e9ec;\n  overflow-x: auto;\n  width: 100%;\n  border-bottom: 0;\n}\n\n.table-nastupna-predavanja th,\n.table-nastupna-predavanja td {\n  padding: 16px 32px 16px 32px;\n  border-bottom: 1px solid #d1d9e2;\n}\n.table-nastupna-predavanja tr:last-child {\n  border-bottom: none;\n}\n.table-nastupna-predavanja th,\n.table-nastupna-predavanja tr {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n.table-nastupna-predavanja th,\n.table-nastupna-predavanja tr,\n.first-column-name {\n  text-align: left;\n  font-family: Inter;\n  letter-spacing: -0.001em;\n  color: #5f6d7e;\n}\n.edit-delete-btn-row {\n  gap: 16px;\n  padding: 12px;\n}\n.table-nastupna-predavanja-column,\n.table-nastupna-predavanja-btn,\n.table-nastupna-predavanja-btn-disabled,\n.delete-nastupno-predavanje-btn,\n.edit-nastupno-predavanje-btn,\n.edit-delete-btn-row {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.table-nastupna-predavanja-custom-border {\n  border-right: 1px solid #d1d9e2;\n}\n.table-nastupna-predavanja th {\n  padding: 16px 0px 16px 24px;\n}\n.table-nastupna-predavanja tr {\n  font-weight: 500;\n}\n.table-nastupna-predavanja-column {\n  flex-direction: column;\n  width: 100%;\n}\n.table-nastupna-predavanja-btn,\n.edit-nastupno-predavanje-btn {\n  background-color: #cb9c2d;\n}\n.table-nastupna-predavanja-btn:hover,\n.edit-nastupno-predavanje-btn:hover {\n  background-color: #9c7926;\n}\n.table-nastupna-predavanja-btn:hover,\n.delete-nastupno-predavanje-btn:hover,\n.edit-nastupno-predavanje-btn:hover {\n  cursor: pointer;\n  transition: background-color 300ms ease-in-out;\n}\n.table-nastupna-predavanja-btn-disabled {\n  cursor: not-allowed;\n  background-color: #818181;\n  opacity: 0.4;\n}\n.delete-nastupno-predavanje-btn,\n.edit-nastupno-predavanje-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n  padding: 8px;\n  border: none;\n}\n.delete-nastupno-predavanje-btn {\n  background-color: #cb2d2d;\n  cursor: pointer;\n}\n\n.delete-nastupno-predavanje-btn:hover {\n  background-color: #8f1c1c;\n}\n.delete-nastupno-predavanje-trash,\n.edit-nastupno-predavanje-icon {\n  width: 24px;\n  height: 24px;\n}\n.edit-nastupno-predavanje-icon,\n.delete-nastupno-predavanje-trash {\n  filter: brightness(0) invert(1) grayscale(100%);\n}\n.table-nastupna-predavanja-btn-disabled,\n.table-nastupna-predavanja-btn {\n  padding: 0px 10px 0px 10px;\n  gap: 6px;\n  border: none;\n  border-radius: 4px;\n  height: 40px;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  width: max-content;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: white;\n}\n.table-nastupna-predavanja-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 100px;\n}\n.table-nastupna-predavanja-status {\n  margin-top: -10px;\n  font-family: Inter;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 15px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  color: #9fa7b2;\n}\n\n.first-column-name {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 18px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
